module.exports = __webpack_public_path__ + "img/Menu-05.d0e41233.png";